export default __webpack_public_path__ + "static/media/hubble.ee1cb619.jpg";